import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',

    [theme.breakpoints.down('lg')]: {
      justifyContent: 'center',
    },
  },
  item: {
    margin: theme.spacing(2, 2, 0, 0),

    [theme.breakpoints.down('lg')]: {
      margin: theme.spacing(1),
    },
  },
}));
